import { useProjectDetailQuery } from "@src/__generated__/graphql";
import { useEffect } from "react";
import type { Store } from "../Store";

export const useFetchProject = (id: string, store: Store) => {
  const { data, refetch, loading, error } = useProjectDetailQuery({
    variables: { id },
    skip: !id,
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (!data?.project) return;

    store.setProject(data);
  }, [data]);

  store.refetchProject = () => {
    refetch();
    store.fetchOurWorkOverview();
  };

  return { data, refetch, loading, error };
};
